export const getSeatTypesFromStorage = () => {
  try {
    const seatTypesData = localStorage.getItem("seatTypes");
    if (!seatTypesData) return [];
    const seatTypes = JSON.parse(seatTypesData);
    if (!Array.isArray(seatTypes)) return [];
    return seatTypes;
  } catch (e) {
    console.error("Error parsing seat types:", e);
    return [];
  }
};
